import React from 'react';
import { BookmarkIcon } from 'lucide-react';
import { PillButton } from '../ui/PillButton';
import { timeLabel } from '../../utils/historyText';
import type { SavedVersion } from '../../types/history';
type SavedVersionsListProps = {
  versions: SavedVersion[];
  onRestore: (version: SavedVersion) => void;
};
export function SavedVersionsList({
  versions,
  onRestore
}: SavedVersionsListProps) {
  if (versions.length === 0) {
    return <div className="flex flex-col items-center px-6 pt-10 text-center" data-id="element-240" data-mp="6yucheq86w7q">
        <BookmarkIcon className="h-[20px] w-[20px] text-pf-faint" strokeWidth={1.8} data-id="element-241" data-mp="bxffflwv3tzv" />
        <p className="mt-2 text-[12.5px] font-semibold text-pf-ink" data-id="element-242" data-mp="fxpleyknmkeq">No saved versions yet</p>
        <p className="mt-1 text-[11.5px] leading-snug text-pf-muted" data-id="element-243" data-mp="kp7obs68mv2c">Choose “Save as New” when restoring, or save any step from its menu.</p>
      </div>;
  }
  return <ul className="flex flex-col pt-[8px]" data-id="element-244" data-mp="3kacy0cfcigsh">
      {versions.map(v => <li key={v.id} className="flex items-center gap-[10px] border-b border-pf-line/70 py-[9px] last:border-b-0" data-id="element-245" data-mp="3oc7zpi16uw6s">
          {v.thumbnail ? <img src={v.thumbnail} alt={`${v.name} preview`} className="h-[53px] w-[72px] shrink-0 rounded-[5px] border border-pf-line object-cover" data-id="element-246" data-mp="jq2vnwbzbuj1" /> : <span className="h-[53px] w-[72px] shrink-0 rounded-[5px] border border-pf-line bg-[#eceef1]" data-id="element-247" data-mp="exrsmklxzsm9" />}
          <div className="min-w-0 flex-1" data-id="element-248" data-mp="9zzrczzequ5e">
            <p className="text-[12px] font-semibold text-pf-ink" data-id="element-249" data-mp="51ogclxdmdll">{v.name}</p>
            <p className="truncate text-[11px] text-pf-muted" data-id="element-250" data-mp="zl25pjbouwm">
              {v.title} · {timeLabel(v.sourceTime)}
            </p>
            <p className="text-[10.5px] text-pf-faint" data-id="element-251" data-mp="3s52z6sgrdk9i">Saved {timeLabel(v.time)}</p>
          </div>
          <PillButton variant="outlineAccent" className="h-[24px] w-[64px] flex-none" onClick={() => onRestore(v)} data-id="element-252" data-mp="3n7kzztsjmjep">
            Restore
          </PillButton>
        </li>)}
    </ul>;
}